export default __webpack_public_path__ + "static/media/peterOlexa.f986c758.png";